import { absolutePath } from "./absolutePath";

export const emailValidations = {
  create: () => absolutePath(`email_validations`),
};
